<template>
    <div>

        <!-- Modal 按鈕 -->
        <b-button class="add-note"
                  v-b-modal="modalID"
                  variant="success" >
            <i class="fa fa-hashtag"></i> ParamSet 拼盤小廚房
        </b-button>



        <!-- Modal 內容 -->
        <b-modal hide-header-close ok-only size="md"
                :id="modalID" ref="modal"
                header-text-variant="light"
                header-bg-variant="teal" >
            <!-- header -->
            <div slot="modal-header">Sensor Parameters Set 拼盤廚房</div>

            <div>

                <div>
                    <div class="block-sm">{{ $t('n.device') }} 分類 *</div>
                    <div class="block-sm">

                        <b-form-radio-group v-model="selected_type" :plain="true" buttons stacked>
                            <template v-for="(_deviceType, idx_dt) in admin_DeviceType_List">
                                <b-form-radio v-if="selected_type == _deviceType.type" :key="idx_dt"
                                                :value="_deviceType.type" :button-variant="'outline-' + _deviceType.variant">
                                    <i :class="$tools.style.classIcon(_deviceType.type, 'block-text')"></i>{{ $t('n.' + _deviceType.type) }} ( {{ _deviceType.type }} )
                                </b-form-radio>
                            </template>
                        </b-form-radio-group>

                    </div>
                </div>
                <div>
                    <div class="block-sm">{{ $t('n.device') }} 版本 *</div>
                    <div class="block-sm">

                        <b-form-radio-group v-model="selected_version" :plain="true" buttons>
                            <b-form-radio v-for="(_ps_Option, key, idx_pso) in paramSets_Options[ selected_type ]" :key="idx_pso" :value="key" :button-variant="'outline-dark'">
                                {{ key }}
                            </b-form-radio>
                        </b-form-radio-group>

                    </div>
                </div>

                <div v-if="selected_version">

                    <b-form-radio v-for="(_set, idx_set) in paramSets_Options[ selected_type ][ selected_version ]" :key="idx_set" :value="_set" v-model="selected_set"
                                        class="param-select block-text-sm" :button-variant="'outline-dark'">
                        <div class="param-set clickable">
                            <span class="set-id">ID : {{ _set.id }}</span>
                            <span class="set-name">{{ _set.name }}</span>
                        </div>
                    </b-form-radio>

                </div>
                                
                <br>

                <b-card v-if="selected_set">
                    <div class="device param-set">
                        <h3 class="block-text">
                            <span class="set-id">ID : {{ selected_set.id }}</span>
                            <span class="set-name">{{ selected_set.name }}</span>
                        </h3>
                        <div class="block-area">
                            Sensor Params：<br>
                            <div class="device-sensor">
                                <div v-for="(ds, idx_ds) in selected_set.sensor_params" :key="idx_ds" class="device-sensor-blocks">
                                    {{ $t('sensor.' + ds) }}<div class="device-unit" v-html="$t('sensor.u_' + ds)"></div>
                                </div>
                            </div>
                            <br>
                            Visualization：<br>
                            <div class="device-sensor">
                                <div v-for="(dv, idx_dv) in selected_set.visualization" :key="idx_dv" class="device-sensor-blocks">
                                    {{ $t('sensor.' + dv) }}<div class="device-unit" v-html="$t('sensor.u_' + dv)"></div>
                                </div>
                            </div>
                        </div>
                        <b-alert v-if="selected_set.note" variant="secondary" show >Note：{{ selected_set.note }}</b-alert>
                        
                    </div>
                </b-card>
                        

            </div>


            <div slot="modal-footer" class="w-100">
                <div class="float-left">
                    <!-- HashTag -->
                    <i class="fa fa-hashtag"></i> {{ selected_type }} - {{ selected_version }} <span v-if="selected_set">- {{ selected_set.id }} - {{ selected_set.name }}</span>
                    
                </div>
                
                <b-btn class="btn-agri float-right" variant="success"   @click="emitValue()" :disabled="checkDisabled">{{ $t('menu.confirm') }}</b-btn>
                <b-btn class="btn-agri float-right" variant="secondary" @click="closeModal()">{{ $t('menu.cancel') }}</b-btn>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import SaltMap from '@/common/salt-map'

export default {
    props: {
        deviceType: {
            type: String,
            required: true,
        },

        deviceHashid: {
            type: String,
        },
    },
    data () {
        return {
            modalID: 'params-selector-modal-',
            paramSets_Options: {},
            selected_type: undefined,
            selected_version: undefined,
            selected_set: undefined,
        }
    },
    mounted () {
        this.getParamSets();

    },
    computed: {
        ...mapState({
            'admin_DeviceType_List': state => state.device.list_deviceTypes,
        }),


        checkDisabled()
        {
            if (this.selected_set == undefined) return true;
            return false;
        },

    },
    watch: {

        selected_type: function (val, oldVal)
        {
            if (val)
            {
                if (this.deviceHashid)
                {
                    this.selected_version = this.deviceHashid.slice(0,2)
                }
                else this.selected_version = 'all'
            }
        },

        selected_version: function (val, oldVal)
        {
            if (this.selected_type)
            {
                let _version_option = this.paramSets_Options[ this.selected_type ]
                if (val)
                {
                    if ( _version_option && _version_option[ val ] && _version_option[ val ].length > 0 )
                    {
                        this.selected_set = this.paramSets_Options[ this.selected_type ][ val ][0]
                    }
                    else { this.selected_set = undefined }
                }
                else if ( _version_option && _version_option['all'] && _version_option['all'].length > 0 )
                {
                    this.selected_version = 'all'
                    this.selected_set = this.paramSets_Options[ this.selected_type ]['all'][0]
                }
                else { this.selected_set = undefined }

            }
            else { this.selected_set = undefined }
        },

        'deviceType': function (val, oldVal)
        {
            if (val)
            {
                this.selected_type = val
            }
        },
        'deviceHashid': function (val, oldVal)
        {
            if (val)
            {
                this.selected_version = val.slice(0,2)
            }
            else this.selected_version = 'all'
        },

    },
    methods: {

        emitValue ()
        {
            if (this.selected_set)
            {
                this.$emit('result-value', { sensor_params: this.selected_set.sensor_params, visualization: this.selected_set.visualization });
                this.closeModal()
            }
        },

        closeModal ()
        {
            this.$refs.modal.hide()
        },

        // GET：取得所有 ParamSets
        getParamSets ()
        {
            this.uploading = true;
            this.selected_set = undefined;
            
            const settings = {}
            this.$store.dispatch('device/getDevice_ParamSets', settings)
            .then( res => {
                this.uploading = false;
                this.arrangeParamSets( res.paramset )
            })
            .catch( err => {
                this.uploading = false;
                this.arrangeParamSets()
            })
        },

        arrangeParamSets (list = [])
        {
            // initialize
            let _options = {}
            this.admin_DeviceType_List.forEach( _typeSetting => {
                _options[ _typeSetting.type ] = {
                    'all': [],
                }

                // 根據 SaltMap 加鹽表裡設定的 version 來建立範本按鈕 
                let _versions = SaltMap.device[ _typeSetting.type ].options
                for (let _ver in _versions)
                {
                    _options[ _typeSetting.type ][ _ver ] = []
                }
            })

            // arrange paramSets to options
            list.forEach( _set => {
                
                if ( _options[ _set.type ][ _set.version ] == undefined ) _options[ _set.type ][ _set.version ] = []

                _options[ _set.type ]['all'].push( _set )
                _options[ _set.type ][ _set.version ].push( _set )
            })
            this.paramSets_Options = _options

            // 選擇器直接指定 type 不可變動
            this.selected_type = this.deviceType
        },

    }
}
</script>

<style lang="scss" scoped>

</style>
